import { ParticipantType } from "../enums";
import { IVariable } from "../types";
import { parseStringToBoolean, string2number } from "../utils";
import { ActiveActivity, ActualizedParticipant, WorkflowStatus } from "../workflowModel/WorkflowStatus";

export const xmlToWfStatus = (xmlString: string): WorkflowStatus => {
    if (xmlString == null || xmlString.length < 0)
        throw new Error("Provided string of workflow status is empty.");

    const parser = new DOMParser();
    const formDoc = parser.parseFromString(xmlString, "text/xml");

    if (formDoc == null)
        throw new Error("Loading of form xml failed!");

    const workflowStatusElement = formDoc.children[0];

    const activeActivities = getActiveActivities(workflowStatusElement);
    const variables = getVariables(workflowStatusElement);
    const isWfEnded = getIsEndedStatus(workflowStatusElement);

    return new WorkflowStatus(activeActivities, variables, isWfEnded);
};

const getIsEndedStatus = (workflowStatusElement: Element) => {
    const ended = workflowStatusElement.getAttribute("ended");
    return parseStringToBoolean(ended, false);
};

const getActiveActivities = (workflowStatusElement: Element): ActiveActivity[] => {
    const activeActivityElements = workflowStatusElement.getElementsByTagName("ActiveActivities")[0].children;
    const activeActivities: ActiveActivity[] = [];

    for (let i = 0; i < activeActivityElements.length; i++) {
        const activeActivityEl = activeActivityElements[i];

        activeActivities.push({
            activityId: activeActivityEl.getAttribute("aAcID") ?? "",
            parentActivityId: activeActivityEl.getAttribute("pAcID") ?? "",
            order: string2number(activeActivityEl.getAttribute("order") ?? "", 0),
            activatedInputTransitionIds: getActivatedInputTrans(activeActivityEl),
            activeParticipants: getActualizedParticipants(activeActivityEl),
        });
    }

    return activeActivities;
};

const getVariables = (workflowStatusElement: Element): IVariable[] => {
    const itemElements = workflowStatusElement.getElementsByTagName("Variables")[0].children;
    const variables: IVariable[] = [];

    for (let i = 0; i < itemElements.length; i++) {
        const item = itemElements[i];
        variables.push({
            name: item.getAttribute("key") ?? "",
            value: item.innerHTML,
        });
    }

    return variables;
};

const getActivatedInputTrans = (activeActivityEl: Element): string[] => {
    const activatedInputTrans = activeActivityEl.getElementsByTagName("ActivatedInputTrans");
    const inputTrans: string[] = [];

    if (!activatedInputTrans.length)
        return inputTrans;

    const tElements = activatedInputTrans[0].children;

    for (let i = 0; i < tElements.length; i++) {
        const telement = tElements[i];
        inputTrans.push(telement.innerHTML);
    }

    return inputTrans;
};

const getActualizedParticipants = (activeActivityEl: Element): ActualizedParticipant[] => {
    const actualizedParticipantElements = activeActivityEl.getElementsByTagName("ActualizedParticipants");
    const actualizedParticipants: ActualizedParticipant[] = [];

    if (!actualizedParticipantElements.length)
        return actualizedParticipants;

    const participantElements = actualizedParticipantElements[0].children;

    for (let i = 0; i < participantElements.length; i++) {
        const participantElement = participantElements[i];

        actualizedParticipants.push({
            type: participantElement.localName as ParticipantType,
            id: participantElement.getAttribute("dbID") ?? "",
            name: participantElement.getAttribute("name") ?? "",
        });
    }

    return actualizedParticipants;
};
